import React, { useEffect, useImperativeHandle, useState } from 'react';
import { CodeInput, Input } from '../../../ui/Input';
import { IoShieldCheckmarkOutline } from 'react-icons/io5';
import { maskCpf } from '../../../../util/mask';
import { Button, TooltipButton } from '../../../ui/Button';
import { useGenericFormValidator } from '../../../../util/genericFormValidator';
import { isValidCPF } from '../../../../util/validators';
import { patternsValidators } from '../../../../model/enum';

export const usePersonalDataModal = ({ modalRef }) => {
    const maxSteps = 4;
    const [currentStep, setCurrentStep] = useState(1);
    const [show, setShow] = useState(false);
    const initialForm = {
        cpf: '',
        fullName: '',
        dateOfBirth: '',
        email: '',
        phone: '',
    };
    const inputsPersonalData = [
        { label: 'Cpf', field: 'cpf', placeholder: 'XXX.XXX.XXX-XX' },
        { label: 'Nome Completo', field: 'fullName', placeholder: '' },
        { label: 'Data de nascimento', field: 'dateOfBirth', placeholder: 'XX/XX/XXXX' },
        { label: 'E-mail', field: 'email', placeholder: 'seu@email.com' },
        { label: 'Telefone', field: 'phone', placeholder: '(XX) 9XXXX-XXXX' },
    ];
    const openModal = (cpf = "") => {
        setShow(true);
        setForm({ ...form, cpf });
    }
    const closeModal = ({ cpf = "", }) => {
        setShow(false);
        setForm(initialForm);
        setCurrentStep(1);
    }
    const personalDataFormRules = {
        cpf: {
            required: true,
            custom: (value) => isValidCPF(value) ? null : 'CPF inválido'
        },
        fullName: {
            required: true,
        },
        dateOfBirth: {
            pattern: patternsValidators.dateOfBirth,
            required: true,
            message: 'Data inválida',
        },
        email: {
            required: true,
            pattern: patternsValidators.email,
            message: 'Email inválido',
        },
        phone: {
            required: true,
            pattern: patternsValidators.phone,
            message: 'Telefone inválido',
        },
    };
    const { form, errors, handleChange, validate, setForm } = useGenericFormValidator(initialForm, personalDataFormRules);


    useImperativeHandle(modalRef, () => ({
        openModal,
    }));

    const handleNextStep = () => {
        setCurrentStep(currentStep + 1);
    }

    const handleSubmit = () => {
        switch (currentStep) {
            case 1: //Dados cadastrais
                onSubmitPersonalData();
                break;
            default:
                break;
        }
    }

    const checkSMSToken = (code) => {
        handleNextStep();
    }

    const onSubmitPersonalData = () => {
        if (validate()) {
            handleNextStep();
        }
    }

    const onSubmitPassword = (password) => {
        const submitForm = {
            cpf: form.cpf,
            fullName: form.fullName,
            email: form.email,
            phone: form.phone,
            password: password
        }
        // cadastrar
    }

    const StepProgress = () => {
        const percent = (currentStep / maxSteps) * 100;
        return (
            <React.Fragment>
                <div className="w-full h-2 bg-gray-300 rounded-full overflow-hidden">
                    <div
                        className="h-full bg-purple-900 rounded-full transition-all duration-300"
                        style={{ width: `${percent}%` }}
                    />
                </div>
            </React.Fragment>
        );
    };

    return {
        closeModal,
        show,
        StepProgress,
        handleSubmit,
        currentStep,
        handleChange,
        form,
        errors,
        inputsPersonalData,
        checkSMSToken,
        onSubmitPassword
    }
}